var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 19,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "reuse-0",
    fill: "#fff",
    d: "M7.086 5.488a.5.5 0 1 0-.976.22l1.063 4.698a.5.5 0 1 0 .976-.22L7.086 5.488Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-1",
    fill: "#fff",
    d: "M14.173 5.488a.5.5 0 0 1 .976.22l-1.063 4.698a.5.5 0 1 1-.976-.22l1.063-4.698Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-2",
    fill: "#fff",
    d: "M10 5.475c0-.262.224-.475.5-.475s.5.213.5.475v4.75a.488.488 0 0 1-.5.475.488.488 0 0 1-.5-.475v-4.75Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 18,
    height: 19,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 .765H0v18h18v-18Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E95D1D",
    d: "M4 5h13.5L15 12H6L4 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E95D1D",
    d: "M5.8 12.4h9.564a.527.527 0 0 0 .507-.382l2.11-7.383a.525.525 0 0 0-.507-.672H4.584l-.377-1.696a.528.528 0 0 0-.515-.413H.528a.527.527 0 0 0 0 1.054H3.27l1.905 8.568c-.56.244-.954.802-.954 1.451 0 .873.71 1.582 1.582 1.582h9.563a.527.527 0 0 0 0-1.055H5.802a.527.527 0 0 1-.001-1.054H5.8Zm10.974-7.382-1.808 6.328H6.224L4.817 5.018h11.957ZM5.272 16.093c0 .873.71 1.582 1.582 1.582.872 0 1.581-.71 1.581-1.582 0-.872-.709-1.581-1.581-1.581-.873 0-1.582.71-1.582 1.581Zm1.582-.527a.528.528 0 1 1 0 1.055.528.528 0 0 1 0-1.055ZM12.728 16.093c0 .873.71 1.582 1.582 1.582.872 0 1.582-.71 1.582-1.582 0-.872-.71-1.581-1.582-1.581-.873 0-1.582.71-1.582 1.581Zm1.582-.527a.528.528 0 1 1 0 1.055.528.528 0 0 1 0-1.055Z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.086 5.488a.5.5 0 1 0-.976.22l1.063 4.698a.5.5 0 1 0 .976-.22L7.086 5.488ZM14.173 5.488a.5.5 0 0 1 .976.22l-1.063 4.698a.5.5 0 1 1-.976-.22l1.063-4.698Z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-1"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.173 5.488a.5.5 0 0 1 .976.22l-1.063 4.698a.5.5 0 1 1-.976-.22l1.063-4.698ZM10 5.475c0-.262.224-.475.5-.475s.5.213.5.475v4.75a.488.488 0 0 1-.5.475.488.488 0 0 1-.5-.475v-4.75Z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-2"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-2"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.7b2d1ad7a1df1d6d90dae56096ed4f7a.svg";
export { ForwardRef as ReactComponent };